<template>
  <div v-if="onlyValue" :class="{'show-txt-rest':readonly,'blur-border': show,'visible-onlyValue': currentValue}" class="table-select-box">
    <el-popover placement="bottom" width="180" trigger="click" v-model="show" :disabled="readonly">
      <div class="level-select">
        <div class="level-select-item" v-for="item in sortList" :key="item.id" @click="valueChange(item.id)">
          <!-- <span class="color-block" :style="{background:itemLevelStyle(item.sort).color}"></span> -->
          <span :style="{color:itemLevelStyle(item.sort).color,background:itemLevelStyle(item.sort).bgColor}">{{item.sort_name}}</span>
          <i v-if="currentValue === item.id" class="icon iconfont iconicon_selected_more_task check"></i>
        </div>
      </div>
      <div :class="{'show-txt-rest':readonly}" slot="reference">
        <span v-if="currentValue" class="level-select-value" :style="{color:itemLevelStyle(sortValue.sort).color,background:itemLevelStyle(sortValue.sort).bgColor}">{{sortValue.sort_name}}</span>
        <span class="table-select-button" v-else>优先级</span>
      </div>
    </el-popover>
  </div>
  <div class="level-status" v-else>
    <el-popover placement="bottom" width="180" trigger="click" v-model="show" :disabled="readonly">
      <div class="level-select">
        <div class="level-select-item" v-for="item in sortList" :key="item.id" @click="valueChange(item.id)">
          <!-- <span class="color-block" :style="{background:itemLevelStyle(item.sort).color}"></span> -->
          <span :style="{color:itemLevelStyle(item.sort).color,background:itemLevelStyle(item.sort).bgColor}">{{item.sort_name}}</span>
          <i v-if="currentValue === item.id" class="icon iconfont iconicon_selected_more_task check"></i>
        </div>
      </div>
      <div :class="{'show-txt-rest':readonly}" slot="reference">
        <span class="only-value" v-if="currentValue">
          <span class="level-select-value" :style="{color:itemLevelStyle(sortValue.sort).color,background:itemLevelStyle(sortValue.sort).bgColor}">{{sortValue.sort_name}}</span>
        </span>
        <span class="add-txt" v-else>优先级</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { taskLevelMap } from "@/utils/const.js"
export default {
  props: ['config', 'value', 'onlyValue', 'defaultValue', 'sortList', 'readonly'],
  data() {
    return {
      isFoucs: false,
      taskLevelMap: taskLevelMap,
      show: false
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || '';
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    sortValue() {
      let data = this.sortList.find(res => res.id == this.currentValue)
      return data ? data : {}
    }
  },
  methods: {
    // sort {
    //   let data = this.sortList.find(res => res.id == this.currentValue)
    //   console.log('--------', this.sortList, this.currentValue, data)
    //   return data ? data : {}
    // },
    itemLevelStyle(level) {
      let current = this.taskLevelMap.filter(item => {
        return item.key === level
      })
      return current.length > 0 ? current[0] : '';
    },
    visibleSelect(val) {
      if (!val) {
        this.isFoucs = false
      }
    },
    valueChange(val) {
      this.show = false
      this.$emit('input', val)
      this.$emit('change', val)
    },
    getBlur() {
      if (this.disabled) { return }
      this.isFoucs = true
      this.$nextTick(() => {
        this.$refs.status.focus()
      })
    },
  }
}
</script>

<style lang="scss">
.level-status {
  display: inline-block;
  position: relative;
  cursor: pointer;
  margin-left: 8px;
}
.color-block {
  width: 12px;
  height: 12px;
  display: inline-block;
  margin-right: 15px;
  border-radius: 2px;
}
.level-select {
  padding: 16px 0;
}
.level-select-item {
  padding: 0 20px;
  cursor: pointer;
  position: relative;
  margin-bottom: 12px;
  .check {
    font-size: 14px;
    position: absolute;
    right: 26px;
    top: 50%;
    transform: translate(0, -50%);
    color: $colorStatus-hoverColor;
  }
  >span {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 28px;
    border-radius: 4px;
  }
}
.level-select-item:last-child {
  margin-bottom: 0;
}
.level-select-value {
  display: inline-block;
  width: 44px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 4px;
}
</style>
